    import React,  { useState, useEffect, useRef } from 'react';
  import { getUserProfile, updateUserProfile } from  '../../../../services/userProfile'
  import validateByType from '../../../../hooks/useFormValidation'
  import { Tab } from 'bootstrap';
import { toast } from 'react-toastify';

  const useUserProfile = () => {
    // Profile form state
    const [profileImage, setProfileImage] = useState(null);
    const [profileForm, setProfileForm] = useState({
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      brand_name: '',
      sector: '',
      country_code : ''
    });

    const [profileErrors, setProfileErrors] = useState({});
    const [profileResult, setProfileResult] = useState(null);

    // Password change state
    const [passwordForm, setPasswordForm] = useState({
      current_password: '',
      password: '',
      password_confirm: '',
    });

    const [passwordErrors, setPasswordErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [passLoading, setPassLoading] = useState(false);
    const [dLoading, setDLoading] = useState(true);
    const [passwordResult, setPasswordResult] = useState(null);
    const overviewTabRef = useRef(null); // ref for overview tab button

    const onTabSwitchToOverview = () => {
      if (overviewTabRef.current) {
        const tabTrigger = new Tab(overviewTabRef.current);
        tabTrigger.show();
      }
    }

    const onCountryCodeChange = (e) => {
      setDLoading(false);
      setProfileForm({ ...profileForm, country_code: e.target.value });
    };

    const handleProfileImageChange = (e) => {
      const file = e.target.files[0];
      if (!file) return;
      setDLoading(false)
      setProfileImage(file);
    };


    // Fetch user data on mount
    useEffect(() => {
      const fetchUserProfile = async () => {
        try {
          const response = await getUserProfile()
          const data = response.data;

          setProfileForm({
            first_name: data.first_name || '',
            last_name: data.last_name || '',
            email: data.email || '',
            phone: data.phone || '',
            brand_name: data.brand_name || '',
            sector: data.sector || '',
            country_code : data.country_code || ''
          });
          setProfileImage(data.profile_image || '')
          // Optional: You can parse country code if your backend returns it
          if (data.phone && data.phone.startsWith('+')) {
            const parts = data.phone.split(' ');
            setCountryCode(parts[0]);
            setProfileForm((prev) => ({
              ...prev,
              phone: parts.slice(1).join(' '),
            }));
          }

        } catch (error) {
          console.error('Failed to load user profile:', error);
        }
      };

      fetchUserProfile();
    }, []);

    // Shared change handler
    const onProfileChange = (e) => {
      setDLoading(false)
      setProfileForm({ ...profileForm, [e.target.name]: e.target.value });
      setProfileErrors({ ...profileErrors, [e.target.name]: undefined });
    };

    const onPasswordChange = (e) => {
      setDLoading(false)
      setPasswordForm({ ...passwordForm, [e.target.name]: e.target.value });
      setPasswordErrors({ ...passwordErrors, [e.target.name]: undefined });
    };

    const onProfileSubmit = async (e) => {
      e.preventDefault();
      setProfileResult(null);

      const errors = validateByType('profileUser', profileForm);
      setProfileErrors(errors);
      if (Object.keys(errors).length > 0) return;

      setLoading(true);
      setDLoading(true);

      try {
        const formData = new FormData();

        // Append all profile form data to FormData
        Object.entries(profileForm).forEach(([key, value]) => {
          formData.append(`user[${key}]`, value);
        });

        // Append the image file if selected
        if (profileImage instanceof File) {
          formData.append('user[profile_image]', profileImage);
        }

        const response = await updateUserProfile(formData);
        toast.success(response?.message, {
          position: "bottom-right",
        })
        if (response.success) {
          setProfileImage(response?.data?.profile_image)
          onTabSwitchToOverview?.(); // switch back to overview tab
        }
      } catch (err) {
        console.error('Profile update failed:', err);
      }

      setLoading(false);
    };


    const onPasswordSubmit = async (e) => {
      e.preventDefault();
      setPasswordResult(null);
      const errors = validateByType('profilePassword', passwordForm); // or 'register' if shared
      setPasswordErrors(errors);
      if (Object.keys(errors).length > 0) return;
      setPassLoading(true);
      setDLoading(true)
      try {
        let response = await updateUserProfile({user:passwordForm});
        if(response.success == true){
          setPasswordForm({
            current_password: '',
            password: '',
            password_confirm: '',
          });
          onTabSwitchToOverview?.(); // switch to overview tab
        }
      } catch (err) {
        console.error('OTP verification failed:', err);
      }
      setPassLoading(false);
    };

    return {
      profileForm,
      profileErrors,
      profileResult,
      onProfileChange,
      onProfileSubmit,

      passwordForm,
      passwordErrors,
      loading,
      passLoading,
      dLoading,
      passwordResult,
      onPasswordChange,
      onPasswordSubmit,
      overviewTabRef,
      onCountryCodeChange,
      handleProfileImageChange,
      profileImage
    };
  };

  export default useUserProfile;
